// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pbCE1","text":"styles_text__z1glm"};